const randomString = require('randomstring');
import axios from 'axios';
export default {
  data() {
    return {
      providers: []
    }
  },
  mounted() {
    const self = this;
    self.providers = null;
  },
  methods: {
    connectAccount(url) {
      //ensure that user has a fully refreshed token to prevent edge-case errors
      const handshake = randomString.generate(16);
      const bearer = axios.defaults.headers.common['Authorization']
      window.localStorage.setItem('handshake', handshake);

      const pseudoForm = document.createElement('form');
      pseudoForm.setAttribute('action', url);
      pseudoForm.setAttribute('method', 'POST');
      pseudoForm.setAttribute('style', 'display:none');

      const input = document.createElement("input");
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'handshake');
      input.setAttribute('value', handshake);

      if (bearer) {
        const token = bearer.split(' ')[1];
        const tokenInput = document.createElement("input");
        tokenInput.setAttribute('type', 'hidden');
        tokenInput.setAttribute('name', 'token');
        tokenInput.setAttribute('value', token);
        pseudoForm.appendChild(tokenInput);
      }

      pseudoForm.appendChild(input);
      document.body.appendChild(pseudoForm);
      pseudoForm.submit();
      document.body.removeChild(pseudoForm);
    },
  },

}



// WEBPACK FOOTER //
// ./src/mixins/SocialLoginMixin/index.js